export const sortFiltersByText = (arr, field = "text") =>
  [...arr].sort((a, b) =>
    String(a[field]).localeCompare(String(b[field]), "pt-BR")
  );
